"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_action_1 = require("./base.action");
var conditions_1 = require("../conditions");
var ShowProactiveChatAction = /** @class */ (function (_super) {
    __extends(ShowProactiveChatAction, _super);
    function ShowProactiveChatAction(invitationService, notificationService) {
        var _this = _super.call(this) || this;
        _this.invitationService = invitationService;
        _this.notificationService = notificationService;
        // Subscribe to chat state notifications.
        _this.notificationService.chatState$.subscribe(function (isChatOpen) {
            _this.isChatOpened = isChatOpen;
        });
        return _this;
    }
    ShowProactiveChatAction.prototype.addCondition = function (condition) {
        // Skill availability must be checked only after all other conditions are fulfilled.
        if (condition instanceof conditions_1.SkillAvailableCondition) {
            this.skillAvailableCondition = condition;
        }
        else {
            _super.prototype.addCondition.call(this, condition);
        }
    };
    ShowProactiveChatAction.prototype.act = function () {
        var _this = this;
        if (this.isChatOpened) {
            console.log('Chat invitation was not shown, chat already open.');
        }
        else {
            // All conditions are met, check if the required skill available before showing an invitation.
            if (this.skillAvailableCondition) {
                console.log('Checking skill availability before showing a chat invitation...');
                this.skillAvailableCondition.observable.subscribe(function (result) {
                    if (result)
                        _this.showInvitation();
                    else
                        console.log('Chat invitation was not shown, no agent with the required skill available.');
                });
            }
            else
                this.showInvitation();
        }
    };
    ShowProactiveChatAction.prototype.showInvitation = function () {
        this.invitationService.showInvitation();
        // Invoke auto-close action if we have any.
        if (this.nextAction) {
            this.nextAction.invoke();
        }
    };
    return ShowProactiveChatAction;
}(base_action_1.BaseAction));
exports.ShowProactiveChatAction = ShowProactiveChatAction;
